import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setMetaTags } from '@/finsight/application/actions/metaTags/actions';
import metaTags from '@/finsight/ui/common/metaTagsConstants';
import { IStratsMetadata } from '@/finsight/infrastructure/repository/StratsRepository/types';
import { initialStratsMetaData } from '@/finsight/application/Strats/constants';

export const useStratsMetadata = (initialMetadata: IStratsMetadata = initialStratsMetaData) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setMetaTags(metaTags.getStratMaker(initialMetadata.filingTitle)));
  }, [initialMetadata]);

  return {
    metadata: initialMetadata,
  };
};
